// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"139":"category","353":"contact","369":"galery","480":"impressum","594":"about"}[chunkId] + "." + {"139":"95599a32","353":"b8532586","369":"97cda3c1","480":"7f83ff86","594":"b5eb846e"}[chunkId] + ".js";
};